import { Star, BadgeCheck, PawPrint, Leaf } from "lucide-react";
import { Reveal } from "./Reveal";

const REVIEWS = [
  { name: "Emma Collins", text: "Feels so soft and smooth. I love it." },
  { name: "Sophia Bennett", text: "Light, smooth, and really pleasant to use." },
];

const BADGES = [
  { icon: BadgeCheck, line1: "GMP", line2: "Certified", iconClass: "text-emerald-600" },
  { icon: PawPrint, line1: "Cruelty", line2: "Free", iconClass: "text-ink" },
  { icon: Leaf, line1: "Vegan", line2: "Formula", iconClass: "text-ink" },
];

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative bg-[#F8F5F2] pt-28 md:pt-36 pb-20 md:pb-24 overflow-hidden"
    >
      <div className="mx-auto max-w-[1300px] px-6 md:px-12">
        <Reveal>
          <h2 className="font-sans font-medium uppercase text-ink text-3xl sm:text-4xl md:text-[2.9rem] leading-[1.15] tracking-[0.08em] text-center">
            Customer
            <br />
            Reviews
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 max-w-[980px] mx-auto">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.15}>
              <figure
                data-testid={`review-card-${i}`}
                className="bg-white/70 border border-ink/8 rounded-[26px] p-8 md:p-10 transition-all duration-700 hover:shadow-[0_30px_60px_rgba(60,45,30,0.10)] hover:-translate-y-1"
              >
                <div className="flex gap-1" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={13} className="fill-ink text-ink" />
                  ))}
                </div>
                <figcaption className="mt-6 font-sans text-[15px] md:text-base text-ink">
                  {r.name}
                </figcaption>
                <blockquote className="mt-2 font-sans italic font-light text-[15px] md:text-[17px] leading-relaxed text-ink/75">
                  “{r.text}”
                </blockquote>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <div className="mt-14 md:mt-16 flex items-center justify-center gap-5 md:gap-8">
            {BADGES.map((b, i) => (
              <span
                key={b.line1}
                data-testid={`badge-${i}`}
                className="w-[74px] h-[74px] md:w-20 md:h-20 rounded-full border border-ink/20 flex flex-col items-center justify-center text-center gap-1"
              >
                <b.icon size={15} strokeWidth={1.6} className={b.iconClass} />
                <span className="font-sans text-[8px] uppercase tracking-wide2 text-ink/75 leading-tight">
                  {b.line1}
                  <br />
                  {b.line2}
                </span>
              </span>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="absolute bottom-0 inset-x-0 border-b border-ink/15" />
    </section>
  );
}
